module.exports = __webpack_public_path__ + "static/img/partner_8.9d8e075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_8.png
// module id = Gk7N
// module chunks = 0